module.exports = __webpack_public_path__ + "img/nonDelegated.746c87a0.png";